import { getFlash, removeFlash } from './flash';

const data = getFlash();
const { message, status } = data || {};
if(message && status) {
  exibe_mensagem_com_status(message, status);
  removeFlash();
}
